import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import { ILearningCenterUrlParams } from '../types';

export const useIdentifySentryUser = (params: {
  companyId: number;
  userId: number;
}) => {
  const { companyId, userId } = params;
  useEffect(() => {
    Sentry.setUser({
      id: userId,
      company_id: companyId,
    });
  }, []);
};

/**
 * Returns the known, valid, global URL params for the Learning Center.
 *
 * If SSO is enabled, we append the `sso` param to the URL.
 */
export const useLearningCenterUrlParams = (config: {
  ssoConnection?: string;
}): ILearningCenterUrlParams => {
  const [urlParams, setUrlParams] = useQueryParams({
    classroomKey: StringParam,
    company: StringParam,
    kioskKey: StringParam,
    sso: StringParam,
    scormKey: StringParam,
  });

  useEffect(() => {
    if (!urlParams.kioskKey) {
      setUrlParams({ sso: config.ssoConnection }, 'replaceIn');
    }
  }, [config.ssoConnection]);

  return urlParams;
};
